import * as Sentry from "@sentry/react";

export function encrypt(str: string, publicKey: string) {
  if (window.pidCrypt == null || window.pidCryptUtil == null) {
    // HPM2Security.js (Zuora's encryption library) failed to load, so the
    // pidCrypt globals are unavailable. Without this guard the failure is
    // silent and we end up submitting empty encrypted values.
    Sentry.captureException(
      new Error("Zuora encryption library (HPM2Security.js) failed to load")
    );
    throw new Error(
      "Zuora encryption library (HPM2Security.js) failed to load"
    );
  }

  const key = window.pidCryptUtil.decodeBase64(publicKey);
  const rsa = new window.pidCrypt.RSA();
  // ASN1 parsing
  const asn = window.pidCrypt.ASN1.decode(window.pidCryptUtil.toByteArray(key));
  const tree = asn.toHexTree();

  // setting the public key for encryption with retrieved ASN.1 tree
  rsa.setPublicKeyFromASN(tree);

  // Base64 encode and encrypt the string
  const crypted = rsa.encrypt(str);

  return window.pidCryptUtil.encodeBase64(
    window.pidCryptUtil.convertFromHex(crypted)
  );
}
